

!function(z) {
    z(document).ready(function() {
var m = z(".team-colors-gl-info-message");
        z(".show-info").click(function(e) {        
            e.preventDefault(),
            m.toggleClass("show")
        }),
        m.on("click", ".close", function(e) {
            e.preventDefault(),
            m.removeClass("show")
        }),
        z(".team-colors-gl-mobile .show-info").click(function(e) {
            e.preventDefault(),
            z(this).parent().find(".team-colors-gl-info-message").addClass("show"),
            z(".team-colors-gl-mobile-info-message-bg").css("display", "block")
        }),
        z(".team-colors-gl-mobile .close").click(function(e) {
            e.preventDefault(),
            z(this).parent().removeClass("show"),
            z(".team-colors-gl-mobile-info-message-bg").css("display", "none")
        }),
        z(".team-colors-gl-mobile-info-message-bg").click(function() {
            z(this).parent().find(".team-colors-gl-info-message").removeClass("show"),
            z(".team-colors-gl-mobile-info-message-bg").css("display", "none")
        }),
        z("#mobile-nav-team-colors").click(function(e) {
            e.preventDefault(),
            z(".team-colors-gl-mobile").addClass("show"),
            z("body").css("overflow", "hidden")
        }),
        z(".team-colors-gl-mobile-back").click(function(e) {
            e.preventDefault(),
            z(".team-colors-gl-mobile").removeClass("show"),
            z("body").attr("style", "")
        }),
        z(".team-colors-gl-desktop .team-colors-gl-select-label").click(function() {
            z(".team-colors-gl-select-list").toggle();
            if (z(".team-colors-gl-select-list").is(":visible")) {
              z(".team-colors-gl-select-list").addClass('is_active');
            } else {
              z(".team-colors-gl-select-list").removeClass('is_active');
            }
        }),
        z(".team-colors-gl-mobile-select").click(function(e) {
            e.preventDefault(),
            z(".team-colors-gl-mobile-select-wrap .team-colors-gl-select-list").slideToggle(),
            z(this).find("svg").fadeToggle(0)
        });
  });
}(jQuery);